import { action } from 'mobx';
import apiCaller from '../utils/api-caller';

const smVersion = 'staymenu-version';

class VersionStore {
  @action check() {
    return apiCaller.Versions.get().then(resp => {
      var currentVersion = window.localStorage.getItem(smVersion);

      if (currentVersion) {
        if (currentVersion === resp.toString()) {
          return true;
        } else {
          window.localStorage.setItem(smVersion, resp);
          return false;
        }
      } else {
        window.localStorage.setItem(smVersion, resp);
        return true;
      }
    });
  }
}

export default new VersionStore();